/* marquee.js — slow on hover; speed up with scroll velocity. Hardened + skips the rAF loop when no marquee. */
(function () {
  'use strict';
  try {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    const marquees = document.querySelectorAll('[data-marquee]');
    if (!marquees.length) return; // nothing to animate — don't spin a forever rAF loop

    marquees.forEach((m) => {
      m.addEventListener('mouseenter', () => m.style.setProperty('--marquee-mult', '0.3'));
      m.addEventListener('mouseleave', () => m.style.setProperty('--marquee-mult', '1'));
    });

    let lastY = window.scrollY, lastTime = performance.now(), mult = 1, target = 1;
    function tick() {
      try {
        const now = performance.now();
        const dt = Math.max(now - lastTime, 16);
        const dy = Math.abs(window.scrollY - lastY);
        const velocity = dy / dt;
        target = Math.min(2.4, 1 + velocity * 0.8);
        mult += (target - mult) * 0.08;
        marquees.forEach((m) => { if (!m.matches(':hover')) m.style.setProperty('--marquee-mult', mult.toFixed(2)); });
        lastY = window.scrollY; lastTime = now;
      } catch (e) { /* keep the loop alive */ }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  } catch (e) { console.error('marquee.js failed', e); }
})();
